import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import PriceListsController from "@/modules/priceLists/PriceListsController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

export default function PriceLists() {
  const canViewPriceLists = useHasPermission(Permission.PRICELISTS_VIEW);

  if (!canViewPriceLists) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Price Lists", current: true }]}
        message="You do not have permission to view price lists."
      />
    );
  }

  return (
    <Layout breadcrumbs={[{ label: "Price Lists", current: true }]}>
      <PriceListsController />
    </Layout>
  );
}
